import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key'

let supabase = null

try {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
} catch (err) {
  console.warn('Supabase client could not be initialized:', err.message)
}

// Module-level recovery flag so that PASSWORD_RECOVERY isn't missed if the
// auth event fires before React components mount their listeners.
let _passwordRecoveryPending = false
if (supabase) {
  supabase.auth.onAuthStateChange((event) => {
    if (event === 'PASSWORD_RECOVERY') _passwordRecoveryPending = true
  })
}
export const consumePasswordRecoveryFlag = () => {
  const flag = _passwordRecoveryPending
  _passwordRecoveryPending = false
  return flag
}

export { supabase }
export default supabase
